module.exports = "../images/provide-fishing-2@2x.jpg?v=82e0743";